import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    canMatch: [noAuthGuard],
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'user',
    canMatch: [authGuard],
    loadChildren: () => import('./user/user.routes').then(m => m.USER_ROUTES),
  },
  { path: '**', redirectTo: 'auth' },
];